import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=6362fa5d&scoped=true&"
import script from "./SettingsList.vue?vue&type=script&lang=js&"
export * from "./SettingsList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=6362fa5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6362fa5d",
  null
  
)

export default component.exports